import React, { useState } from 'react';
import ImageLogo from './components/Image';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from "react-router-dom";

const Header = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleSignOut = () => {
    try {
      navigate('/dashboard');
    } catch (error) {
    }
  };

  return (
    <header>
      <button
        className="menu-toggle"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        ☰
      </button>

      <div className={`header ${isMenuOpen ? 'show' : ''}`}>
        <ImageLogo id="logo" src="\virsatlogo.png" alt="Virsat Logo" width="150" height="auto" />

        <nav>
          <ul>
            <li><a href="/">Home</a></li>

            <li className="submenu">
              <a href="#">Training Courses</a>
              <ul className="submenu-list">
                <li><a href="/fundamentals">Training Fundamentals</a></li>
                <li><a href="/life-saving">Life-Saving Rules</a></li>
                <li><a href="/driving-pro">Driving Safety</a></li>
                <li><a href="/module-videos">Sample Videos</a></li>
              </ul>
            </li>

       

            <li><a href="/pricing">Prices</a></li>

            <li className="submenu">
              <a href="#">Purchase</a>
              <ul className="submenu-list">
                <li><a href="/pclicense">PC License</a></li>
                {/* <li><a href="/vrlicense">VR License</a></li> */}
                <li><a href="/comingsoon">VR License</a></li>

              </ul>
            </li>

            <li><a href="/gameplay">Play Now</a></li>

                 <li className="submenu">
              <a href="#">About us</a>
              <ul className="submenu-list">
                <li><a href="/About">About Virsat</a></li>
                <li><a href="/Faq">FAQs</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </li>

            <li className='auth-buttons'>
              {user ? (
                <button className="header-button" onClick={handleSignOut}>Dashboard</button>
              ) : (
                <button className="header-button" onClick={() => navigate('/login')}>Business Login</button>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;